import { Route, Routes } from 'react-router-dom';
import { RestaurantMainPage } from '../pages/restaurants/RestaurantMainPage';

export const RestaurantsRouter = () => {
    return (
        <Routes>
            <Route path="/" element={<RestaurantMainPage />} />
        </Routes>
    );
};
